import { render, staticRenderFns } from "./KeywordSuggest.vue?vue&type=template&id=3f57038d&scoped=true"
import script from "./KeywordSuggest.vue?vue&type=script&lang=js"
export * from "./KeywordSuggest.vue?vue&type=script&lang=js"
import style0 from "./KeywordSuggest.vue?vue&type=style&index=0&id=3f57038d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f57038d",
  null
  
)

export default component.exports